module.exports = __webpack_public_path__ + "public/images/modals/netw-start-conversation-tablet.62e7f6e3ff82c8035070686ce94ce2ca.png";